import { FormikWrapper, FormSelect } from '@uncinc/uncinc-react-kitchen-sink';
import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { TextField } from '../../../components';

import './style.scss';

const SearchForm = ({ onSubmit, value, setValue, contentType, setContentType, className }) => {
  const { t } = useTranslation();
  const options = [
    { value: 'basic_page', label: t('filters.type.types.basic_page') },
    { value: 'article', label: t('filters.type.types.article') },
    { value: 'help_page', label: t('filters.type.types.help_page') },
    { value: 'vacancy', label: t('filters.type.types.vacancy') },
  ];

  return (
    <div className="SearchForm">
      <FormikWrapper className="SearchForm">
        <TextField
          title={t('filters.search.query.label')}
          fieldName="query"
          required
          placeholder={t('filters.search.query.placeholder')}
          onChange={(e) => { setValue(e); }}
        />

        <FormSelect
          options={options}
          fieldName="type"
          title={t('filters.type.label')}
          className="Select"
          required
          defaultValue={{ value: contentType, label: contentType }}
          classNamePrefix="Select__select"
          onChange={(e) => { setContentType(e); }}
        // eslint-disable-next-line react/jsx-boolean-value
        />

      </FormikWrapper>
    </div>
  );
};

SearchForm.defaultProps = {
  className: '',
};

export default SearchForm;
